import connection from './config'

/**
 *  获取 购买vip 价格
 * @param goodsType
 */
export const goodsSearch = (goodsType = 'SKILL') => {
  return connection.get(`/api/v1/goods/search?goodsType=${goodsType}`)
}

/**
 *  通过memberId获取 购买vip 价格
 * @param goodsType vip类型 'SVIP'，'VIP'
 */
export const goodsSearchMemberId = (goodsType = 'SKILL', memberId) => {
  return connection.get(`/api/v1/goods/search/${memberId}?goodsType=${goodsType}`)
}

/**
 * VIP到期时间
 */
export const skillPackageExpire = () => {
  return connection.get(`/api/v1/skill_package/expire`)
}

/**
 * 补差价接口
 */
export const skillPackageExpireAndUpgrade = () => {
  return connection.get(`/api/v1/skill_package/expireAndUpgrade`)
}

/**
 * 创建订单
 * @param goodsId 购买ID
 */
export const createOrder = (goodsId, resource = 'shop') => {
  return connection.get(`/api/v1/pay/createOrder?goodsId=${goodsId}&source=${resource}`)
}

/**
 * 微信下单
 * @param orderid 支付id
 * @param openid openid
 * @returns {*}
 */
export const unifiedOrder = (orderid, openid) => {
  return connection.post(`/api/v1/pay/unifiedOrder?orderId=${orderid}&openid=${openid}`)
}

/**
 * 获取是否是新用户
 * @param memberId
 */
export const tipsRead = (memberId) => {
  return connection.post(`/api/v1/member/common/tips/read/1?memberId=${memberId}`)
}

/**
 * 是否vip过期
 * @returns {*}
 */
export const expireTip = () => {
  return connection.get(`/api/v1/skill/display/expire/tip`)
}

/**
 * 根据member查询儿童拥有的技能详情,按学期
 * @returns {*}
 */
export const getSkillSingleByMember = () => {
  return connection.get(`/api/v1/skill/get_skill_single_by_member`)
}

// 小天才获取小孩技能
export const getSkillSingleByMemberXtc = () => {
  return connection.get(`/api/v1/skill/list`)
}
